import { Component, Input } from '@angular/core';
import { EyeglassPrescriptionResponse } from '@gandalf/model/eyeglass-prescription-response';
import { DATE_FORMATS } from '@shared/constants/date-format.constants';

@Component({
	selector: 'pms-eyeglass-rx-dates',
	templateUrl: './eyeglass-rx-dates.component.html',
	styles: [],
	standalone: false,
})
export class EyeglassRxDatesComponent {

	dateFormat = DATE_FORMATS.MM_DD_YYYY;

	@Input()
	eyeglassPrescription: EyeglassPrescriptionResponse;

	constructor() {
	}

}
